import React, { useEffect, useState } from 'react';
import { Link } from 'gatsby';
import {
  Button,
  Row,
  Container,
  Card,
  CardBody,
  CardHeader,
  Offcanvas,
  OffcanvasBody,
  OffcanvasHeader,
} from 'reactstrap';

import { graphql } from 'gatsby';

import * as routes from '../../routes';
import externalJobsStates from '../../data/externalJobsStates';
import SEO from '../../components/common/SEO';
import JobSearchInputBlock from '../../components/search/JobSearchInputBlock';
import JobPost from '../../templates/jobs/dynamic-job-post';
import LoadingSpinner from '../../components/common/LoadingSpinner';

const allPositions = require('../../data/allPositions');

const formatString = (string) =>
  string.toLowerCase().replace(/[^a-z0-9]+/g, '-');

const buildStateJobsPath = ({ stateCode, stateName }) =>
  `/dental-jobs/${formatString(stateName)}/`;

const Zones = (props) => {
  const allInternalJobsLength = props.data.allInternalJobs.totalCount;
  const [jobId, setJobId] = useState(null as string | null);

  useEffect(() => {
    if (props.location.search && props.location.search.includes('id')) {
      const params = new URLSearchParams(props.location.search);
      const jobId = params.get('id');
      setJobId(jobId);
    }
  }, [props.location]);

  return (
    <>
      <SEO
        keywords="Dental jobs, Dental Positions, Near Me"
        title="View Dental Jobs and Dental Practice Positions Near Me"
        description={`Browse from ${allInternalJobsLength} dental jobs. Start your new career with DentalPost today. Apply for any dental position in as simple as one-click!`}
      />
      <Offcanvas
        isOpen={jobId != null}
        direction="end"
        style={{ width: '900px', maxWidth: '100%' }}
        toggle={() => setJobId(null)}
      >
        <OffcanvasHeader toggle={() => setJobId(null)} />
        <OffcanvasBody>
          {jobId ? <JobPost jobId={jobId} /> : <LoadingSpinner />}
        </OffcanvasBody>
      </Offcanvas>
      <div className="jumbotron bg-secondary text-white text-center">
        <h1>Browse Dental Jobs Near You</h1>
        <p>You must be a registered member to apply to job postings.</p>
        <Button tag={Link} to={routes.toGetStarted} outline color="light">
          Register Now
        </Button>
      </div>
      <Container>
        <Card className="mb-3">
          <CardBody>
            <JobSearchInputBlock
              classNames="border-0 w-100"
              header={'Find Dental Industry Jobs on DentalPost'}
            />
          </CardBody>
        </Card>
        <Card className="mb-3">
          <CardHeader>Dental Jobs by Position</CardHeader>
          <CardBody>
            <div style={{ columnCount: 3 }}>
              {allPositions.map(({ position, specialty, display, url }) => (
                <div key={url}>
                  <Button
                    tag={Link}
                    to={`/dental-jobs/${url}-jobs/`}
                    color="link"
                  >
                    {display} Jobs
                  </Button>
                </div>
              ))}
            </div>
          </CardBody>
        </Card>

        <Card className="mb-3" id="jobs-by-state">
          <CardHeader>Dental Jobs by State</CardHeader>
          <CardBody>
            <div style={{ columnCount: 4 }}>
              {externalJobsStates.map(({ code, name }) => (
                <div key={code}>
                  <Button
                    tag={Link}
                    to={buildStateJobsPath({
                      stateCode: code,
                      stateName: name,
                    })}
                    color="link"
                  >
                    {name}
                  </Button>
                </div>
              ))}
            </div>
          </CardBody>
        </Card>

        <Card className="mb-3" id="jobs-by-state">
          <CardHeader>More</CardHeader>
          <CardBody>
            <Row>
              <Button
                tag={Link}
                to="/dental-jobs/jobs-by-metro-area"
                color="link"
              >
                Browse Dental Jobs by Metro Area
              </Button>
            </Row>
            <Row>
              <Button tag={Link} to="/dental-jobs/jobs-by-city" color="link">
                Browse Dental Jobs by City/Town
              </Button>
            </Row>
            <Row>
              <Button tag={Link} to="/dental-jobs/jobs-in-canada" color="link">
                Browse Dental Jobs in Canada
              </Button>
            </Row>
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default Zones;

export const pageQuery = graphql`
  query {
    allInternalJobs: allJobPostingsCsv(
      filter: { source: { eq: "DentalPost" } }
    ) {
      totalCount
    }
  }
`;
